import React from "react";

const AppsIcon = ({
  active = false,
  filledIcon = false,
}: {
  active?: boolean;
  filledIcon?: boolean;
}) => {
  const fillColor = active ? "#703DDE" : "#5F6368";

  return filledIcon ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.66658 1.33325H1.99992C1.59992 1.33325 1.33325 1.59992 1.33325 1.99992V6.66658C1.33325 7.06659 1.59992 7.33325 1.99992 7.33325H6.66658C7.06659 7.33325 7.33325 7.06659 7.33325 6.66658V1.99992C7.33325 1.59992 7.06659 1.33325 6.66658 1.33325ZM6.66658 8.66658H1.99992C1.59992 8.66658 1.33325 8.93325 1.33325 9.33325V13.9999C1.33325 14.3999 1.59992 14.6666 1.99992 14.6666H6.66658C7.06659 14.6666 7.33325 14.3999 7.33325 13.9999V9.33325C7.33325 8.93325 7.06659 8.66658 6.66658 8.66658ZM13.9999 1.33325H9.33325C8.93325 1.33325 8.66658 1.59992 8.66658 1.99992V6.66658C8.66658 7.06659 8.93325 7.33325 9.33325 7.33325H13.9999C14.3999 7.33325 14.6666 7.06659 14.6666 6.66658V1.99992C14.6666 1.59992 14.3999 1.33325 13.9999 1.33325ZM13.9999 8.66658H9.33325C8.93325 8.66658 8.66658 8.93325 8.66658 9.33325V13.9999C8.66658 14.3999 8.93325 14.6666 9.33325 14.6666H13.9999C14.3999 14.6666 14.6666 14.3999 14.6666 13.9999V9.33325C14.6666 8.93325 14.3999 8.66658 13.9999 8.66658Z"
        fill="#1D2330"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.5 4.58333C2.5 3.43274 3.43274 2.5 4.58333 2.5H7.15307C8.30366 2.5 9.2364 3.43274 9.2364 4.58333V7.15352C9.2364 8.30412 8.30366 9.23685 7.15307 9.23685H4.58333C3.43274 9.23685 2.5 8.30411 2.5 7.15352V4.58333ZM4.58333 3.875H7.15307C7.54427 3.875 7.8614 4.19213 7.8614 4.58333V7.15352C7.8614 7.54472 7.54427 7.86185 7.15307 7.86185H4.58333C4.19213 7.86185 3.875 7.54472 3.875 7.15352V4.58333C3.875 4.19213 4.19213 3.875 4.58333 3.875Z"
        fill={fillColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.7633 4.58333C10.7633 3.43274 11.6961 2.5 12.8467 2.5H15.4164C16.567 2.5 17.4997 3.43274 17.4997 4.58333V7.15352C17.4997 8.30412 16.567 9.23685 15.4164 9.23685H12.8467C11.6961 9.23685 10.7633 8.30411 10.7633 7.15352V4.58333ZM12.8467 3.875H15.4164C15.8076 3.875 16.1247 4.19213 16.1247 4.58333V7.15352C16.1247 7.54472 15.8076 7.86185 15.4164 7.86185H12.8467C12.4555 7.86185 12.1383 7.54472 12.1383 7.15352V4.58333C12.1383 4.19213 12.4555 3.875 12.8467 3.875Z"
        fill={fillColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.8467 10.7631C11.6961 10.7631 10.7633 11.6959 10.7633 12.8465V15.4167C10.7633 16.5673 11.6961 17.5 12.8467 17.5H15.4164C16.567 17.5 17.4997 16.5673 17.4997 15.4167V12.8465C17.4997 11.6959 16.567 10.7631 15.4164 10.7631H12.8467ZM15.4164 12.1381H12.8467C12.4555 12.1381 12.1383 12.4553 12.1383 12.8465V15.4167C12.1383 15.8079 12.4555 16.125 12.8467 16.125H15.4164C15.8076 16.125 16.1247 15.8079 16.1247 15.4167V12.8465C16.1247 12.4553 15.8076 12.1381 15.4164 12.1381Z"
        fill={fillColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.5 12.8465C2.5 11.6959 3.43274 10.7631 4.58333 10.7631H7.15307C8.30366 10.7631 9.2364 11.6959 9.2364 12.8465V15.4167C9.2364 16.5673 8.30366 17.5 7.15307 17.5H4.58333C3.43274 17.5 2.5 16.5673 2.5 15.4167V12.8465ZM4.58333 12.1381H7.15307C7.54427 12.1381 7.8614 12.4553 7.8614 12.8465V15.4167C7.8614 15.8079 7.54427 16.125 7.15307 16.125H4.58333C4.19213 16.125 3.875 15.8079 3.875 15.4167V12.8465C3.875 12.4553 4.19213 12.1381 4.58333 12.1381Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default AppsIcon;
